import type { Point } from "./types";

/**
 * Bounding rectangle of all polygon vertices
 */
export function boundingRectOfPolygons(
  polygons: readonly (readonly Point[])[]
): Point[] | null {
  if (!polygons.length) {
    return null;
  }
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  for (const poly of polygons) {
    for (const p of poly) {
      minX = Math.min(minX, p.x);
      maxX = Math.max(maxX, p.x);
      minY = Math.min(minY, p.y);
      maxY = Math.max(maxY, p.y);
    }
  }
  if ([minX, minY, maxX, maxY].some((v) => !Number.isFinite(v))) {
    return null;
  }
  const x = minX;
  const y = minY;
  const w = Math.max(maxX - minX, 1);
  const h = Math.max(maxY - minY, 1);
  return [
    { x, y },
    { x: x + w, y },
    { x: x + w, y: y + h },
    { x, y: y + h },
  ];
}
